// Lib
import { compose, defaultProps } from '../../../node_module_clones/recompose';

// Components
import poiDecorator from './poiDecorator';

// Constants
import { PoiType } from './poiConstants';

export default compose(
    defaultProps({
        poiType: PoiType.search,
        poiData: {
            count: 1,
        },
    }),
    poiDecorator,
);
